export default {
	methods: {
		inputPos(event) {
			const obj = event.changedTouches ? event.changedTouches[0] : event
			const { clientX, clientY } = obj
			return { x: clientX, y: clientY }
		}
	}
}
